import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Header from '../../components/Header';

const DuplicateDeclined = (props) => {
  const { checkinData, navigate, params, searchParams } = props;
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <div className="content">
        <p>Unfortunately, we are unable to approve your request for credit due to having an existing credit application submitted in the last 30 days. You are welcome to resubmit a credit application with us after 30 days from the date of your existing application.</p>
      </div>
    </div>
  );
};

DuplicateDeclined.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(DuplicateDeclined);
